<template>
  <label class="checkbox-wrapper" @click.stop>
    <input
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="checkmark"></span>
    <span v-if="label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  props: ['value', 'label', 'disabled'],
};
</script>
<style lang="scss" scoped>
@import '@/scss/base.scss';
.checkbox-wrapper {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: 20px;
  margin: 8px 10px;
  position: relative;
  padding-left: 30px;
  @include noselect();
  input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;
    &:not(:disabled) ~ .checkmark {
      background-color: #e2e9ee;
    }
    &:checked ~ .checkmark {
      background-color: $mainColor;
      &:after {
        display: block;
      }
    }
  }
  .checkmark {
    background-color: #d9d9d9;
    border-radius: 4px;
    height: 20px;
    left: 0;
    position: absolute;
    top: 0;

    @include transition($transition);
    width: 20px;
    &:after {
      border: solid #fff;
      border-width: 0 2px 2px 0;
      content: '';
      display: none;
      height: 10px;
      left: 8px;
      position: absolute;
      top: 4px;
      @include transform(rotate(45deg));
      width: 5px;
    }
  }
  &:hover input:checked ~ .checkmark {
    background-color: rgba($color: $mainColor, $alpha: 0.8)
  }
}
</style>
